module.exports = __webpack_public_path__ + "static/media/LSM_QKDMSolu.9afc481d.gif";